class GiftService {
  async allGifts({ condition, page = 1 }) {
    try {
      const res = await window.axios.get(`/api/v1/admin/gifts/${page}`, { params: condition });
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  async giftById({ id }) {
    try {
      const res = await window.axios.get('/api/v1/admin/gifts/gift', { params: { id } });
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  async updateGift(gift) {
    try {
      const res = await window.axios.put('/api/v1/admin/gifts', gift);
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  async deleteGift({ id }) {
    try {
      const res = await window.axios.delete(`/api/v1/admin/gifts?id=${id}`);
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  async createGift(gift) {
    try {
      const res = await window.axios.post('/api/v1/admin/gifts', gift);
      return res.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }
}

module.exports = GiftService;
